import { connect } from 'react-redux'
import { ReviewDraftProduct } from '../../components/GenericProductConfig/ReviewDraftProduct'
import * as actions from './actions.es6'

const mapStateToProps = state => ({
  open: !!state.genericProducts.reviewDraft,
  reviewDraft: state.genericProducts.reviewDraft,
  currentProduct: state.genericProducts.currentProduct,
  importDraftLoader: state.genericProducts.importDraftLoader,
  importDraftError: state.genericProducts.importDraftError,
  importedDraftProduct: state.genericProducts.importedDraftProduct
})

const mapDispatchToProps = dispatch => ({
  onImport: jobId => dispatch(actions.importDraftProductRequest(jobId)),
  onClose: () => dispatch(actions.clearReviewDraft())
})

export const ReviewDraftProductContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReviewDraftProduct)
